import React from "react";

export const APPROVAL_STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  pending: { bg: "#ffe0b3", color: "#b76b00" },
  processing: { bg: "#cfe8fc", color: "#276ada" },
  approved: { bg: "#d2f5d2", color: "#2a6b2a" },
  rejected: { bg: "#fddede", color: "#d93025" },
  cancelled: { bg: "#e2e3e5", color: "#383d41" },
};

const DEFAULT_COLORS = { bg: "#E2E3E5", color: "#383D41" };

export function RequestBadge({ label, bg, color }: { label: string; bg: string; color: string }) {
  return (
    <div
      style={{
        display: "inline-block",
        padding: "3px 7px",
        borderRadius: "0.525rem",
        fontSize: "0.75rem",
        textAlign: "center",
        backgroundColor: bg,
        color,
        border: "0.2px solid",
        borderColor: `${color}50`,
      }}
    >
      {label}
    </div>
  );
}

/** Pending / Processing / Approved / Rejected badge. Shows "—" when there is no status. */
export function ApprovalStatusBadge({ status }: { status?: unknown }) {
  const raw = String(status ?? "").trim().toLowerCase();
  if (!raw) return <>—</>;
  const colors = APPROVAL_STATUS_COLORS[raw] || DEFAULT_COLORS;
  const label = raw.charAt(0).toUpperCase() + raw.slice(1);
  return <RequestBadge label={label} bg={colors.bg} color={colors.color} />;
}

export default ApprovalStatusBadge;
